<template>
  <div class="container pt-5 mt-5">
    <div class="mt-5 text-justify">
      <h1><b>About Us</b></h1>
    </div>
    <div class="text-justify mt-3">
      <h4>
        The AamCart.com Web site and iOS & Android apps is operated by or on
        behalf of DrillMaps India Private. Limited.
      </h4>
      <h4>
        Aam Cart is the responsible bridge between our community of farmers and
        consumers of fresh fruits and vegetables. In an era where all of us are
        very cautious of what we consume, especially the perishables, Aam Cart
        brings in the expertise of bringing the responsibly grown, handled,
        shipped and delivered to be brought to you straight from the community
        of our farmers. Amongst, all the produce on our list, to list a few
        examples, we source our Raw Turmeric from farmers of Meghalaya &
        Rajasthan, Watermelons and Muskmelons from farmers of Rajasthan &
        Haryana, most of the gourds from farmers of West UP, Apricots from
        farmers of Ladakh.
      </h4>
    </div>
    <div class="text-justify mt-5">
      <h4>
        We feel that it is our responsibility that our consumers should have an
        option to eat right, while our farmers get dues for their hard work with
        respect.
      </h4>
    </div>
    <div class="text-justify">
      <h4>
        We are happy to have 89 farmer partners (Aam Cart Mitras) onboard with
        us as of May 2020 and more joining us as a matter of routine.
      </h4>
    </div>
    <div class="text-justify mb-5">
      <h4>
        We look forward to serving you with an awesome customer experience, now
        and onwards.
      </h4>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
#app {
  @import url("https://fonts.googleapis.com/css2?family=Anton&family=Lobster&family=Merriweather:wght@900&family=Play&display=swap");
}
</style>
